import { render, staticRenderFns } from "./kcjsgm.vue?vue&type=template&id=62af138e&scoped=true&"
import script from "./kcjsgm.vue?vue&type=script&lang=js&"
export * from "./kcjsgm.vue?vue&type=script&lang=js&"
import style0 from "./kcjsgm.vue?vue&type=style&index=0&id=62af138e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62af138e",
  null
  
)

export default component.exports